module.exports = __webpack_public_path__ + "img/emergency-medicine.4ca8676b.png";